import script from "./JobsPanelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobsPanelList.vue?vue&type=script&setup=true&lang=ts"

import "./JobsPanelList.vue?vue&type=style&index=0&id=5b094d60&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b094d60"]])

export default __exports__